module.exports = __webpack_public_path__ + "static/media/secretagreement.f302f349.png";